import type { pluginSlotViewer } from '@wix/ricos';
import { FORMS_INTEGRATION_TYPE } from '@wix/communities-blog-client-common';
import { type AppI18n, withAppI18n } from '../with-app-i18n';
import FormSlotViewerBlock from './form-slot-viewer-block';

type ViewerSlotConfig = NonNullable<Parameters<typeof pluginSlotViewer>[0]>;
type SlotErrorHandler = NonNullable<ViewerSlotConfig['onError']>;

/**
 * The viewer slot plugin config. Memoise the result on the caller side: the ricos viewer wrapper
 * is a PureComponent and builds its plugins from it.
 *
 * The block ships with the ricos viewer, like every other plugin's viewer component: the
 * server renders the wrapper and the sized placeholder without fetching anything. Only the Wix
 * Forms renderer is lazy (see `form-renderer.ts`), and only in the browser.
 */
export const createFormsSlotViewerConfig = (
  i18n: AppI18n,
  onError?: SlotErrorHandler,
): ViewerSlotConfig => ({
  integrations: { [FORMS_INTEGRATION_TYPE]: { Component: withAppI18n(FormSlotViewerBlock, i18n) } },
  onError,
});
